// Fonte di acquisizione dell'iscritto: ?utm_source=... (o ?ref=...) del link
// con cui l'utente atterra sul sito. Va letta all'avvio perche' la navigazione
// SPA perde la query string prima che l'utente apra la registrazione.
//
// sessionStorage e non localStorage: la fonte vive solo finche' la scheda e'
// aperta. Chi torna in un'altra sessione resta senza fonte, scelta voluta per
// non lasciare nulla sul dispositivo oltre la visita.

const STORAGE_KEY = "signup_source";

// First-touch: se la sessione ha gia' una fonte, un link successivo non la
// sovrascrive. try/catch su ogni accesso perche' lo storage puo' essere
// bloccato (navigazione privata, impostazioni del browser).
export function captureSignupSource(): void {
  try {
    const params = new URLSearchParams(window.location.search);
    const source = params.get("utm_source") || params.get("ref");
    if (source && !sessionStorage.getItem(STORAGE_KEY)) {
      sessionStorage.setItem(STORAGE_KEY, source);
    }
  } catch {
    // Storage non disponibile: la registrazione resta senza fonte.
  }
}

export function getSignupSource(): string | undefined {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || undefined;
  } catch {
    return undefined;
  }
}
